<template>
<div class="chapter">
<div class="inner_page">
<p class="author"><strong>Marcellus Andrews</strong></p>
<h1 class="h1"><a id="page_i"></a><strong>THE POLITICAL ECONOMY OF HOPE AND FEAR</strong></h1>
<p class="subtitle"><strong><span class="small">CAPITALISM AND THE<br/>BLACK CONDITION IN AMERICA</span></strong></p>
<p class="publisher"><img alt="image" src="images/pub.jpg"/></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// ch00_fm01_title.vue?5b14f1b4